import { Column } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

// The tokens are live RingCentral credentials. They stay audited (the trail
// shows a refresh or reconnect happened) but their values are redacted from
// _audit (PD-16786).
@Entity(
	'm_ringcentral_plugin_call_log_token',
	{},
	{ auditRedactedProperties: ['accessToken', 'refreshToken'] },
)
export class RingCentralCallLogTokenEntity extends BaseEntity {
	@Column('text', {
		name: 'm_ringcentral_plugin_accessToken',
	})
	public accessToken!: string;

	@Column('text', {
		name: 'm_ringcentral_plugin_refreshToken',
	})
	public refreshToken!: string;

	@Column('varchar', {
		name: 'm_ringcentral_plugin_endpointId',
		length: 255,
	})
	public endpointId!: string;

	@Column({
		type: 'int',
		name: 'm_ringcentral_plugin_userId',
		unsigned: true,
	})
	public userId!: number;
}
